import { Journey } from 'Global/Journey/Types/Journey';
import { fetchFreightDetailCalculation } from 'Services/Api/_HumanWritten/PricingService/PricingService';

interface HandleFreightCalculationFetchParams {
	userId: string;
	journey: Journey;
	freightTypeId: string;
	freightCategoryId: string;
	quantity: number | null;
	weight: number | null;
	width: number | null;
	height: number | null;
	length: number | null;
}

export const handleFreightCalculationFetch = (state: HandleFreightCalculationFetchParams) => {
	const { userId, journey, freightTypeId, freightCategoryId, quantity, weight, width, height, length } = state;

	if (!userId) {
		throw new Error('UserId cannot be empty');
	}
	if (quantity === null) {
		throw new Error('The value quantity cannot be null');
	}
	if (weight === null) {
		throw new Error('The value weight cannot be null.');
	}
	if (width === null) {
		throw new Error('The value width cannot be null.');
	}
	if (height === null) {
		throw new Error('The value height cannot be null.');
	}
	if (length === null) {
		throw new Error('The value length cannot be null.');
	}

	// Examples of calcuation:
	// - 6.6667 ft³ @ $1.00/ft³
	// - 1 unit @ $75.00/unit

	return fetchFreightDetailCalculation({
		userId,
		journey,
		freightTypeId,
		freightCategoryId,
		quantity,
		weight,
		width,
		height,
		length,
	});
};
